import React, { useMemo } from 'react';
import { useAssessmentContext } from '../../../../../AssessmentContext';
import CapabilityQuestionSet from './CapabilityQuestionSet';
import { getPageCapabilities } from 'js/engines/CapabilitiesAssessment/utils';
import { Card, CardBody } from 'reactstrap';
import AdditionalElement from './AdditionalElement';
export function CapabilitiesPage({ page, header }) {
  const selectedCapabilities = page.selectedCapabilities;
  const { capabilitySets } = useAssessmentContext();

  const capabilitySet = useMemo(
    () =>
      capabilitySets[page.capabilitySetId] ?? {
        capabilities: [],
      },
    [capabilitySets, page.capabilitySetId]
  );

  const pageCapabilities = useMemo(() => {
    return getPageCapabilities(capabilitySet, selectedCapabilities);
  }, [capabilitySet, selectedCapabilities]);

  return (
    <>
      {page.capabilityElements.map((capabilityElement, i) => (
        <Card key={capabilityElement.guid}>
          <CardBody>
            {i === 0 && header}
            <CapabilityQuestionSet
              key={capabilityElement.guid}
              capabilityQuestion={capabilityElement}
              capabilities={pageCapabilities}
            />
            {page.additionalElements.map((additionalElement) => (
              <AdditionalElement
                key={additionalElement.guid}
                page={page}
                element={additionalElement}
                capabilityElement={capabilityElement}
              />
            ))}
          </CardBody>
        </Card>
      ))}
    </>
  );
}

export default CapabilitiesPage;
